module.exports = __webpack_public_path__ + "static/media/TeamCulturePoor.1169397a.png";